import { z } from 'zod';
import { LeadSchemas, LeadResponseSchemas } from '../domain/leads';

/**
 * API contracts for leads endpoints
 * Grouped by route collection for better organization
 */

/**
 * Request schemas for leads endpoints
 */
export const LeadRequestSchemas = {
  subscription: LeadSchemas.create,
};

/**
 * Leads API collection - all /leads routes
 */
export const LeadsAPI = {
  subscription: {
    request: LeadRequestSchemas.subscription,
    response: LeadResponseSchemas.subscription,
  },
};

// Export request schema types
export type LeadSubscriptionRequest = z.infer<
  typeof LeadRequestSchemas.subscription
>;

// Export response types (from domain schemas)
export type LeadSubscriptionResponse = z.infer<
  typeof LeadResponseSchemas.subscription
>;

// Export API types (for convenience)
export type LeadsApiSubscriptionRequest = z.infer<
  typeof LeadsAPI.subscription.request
>;
export type LeadsApiSubscriptionResponse = z.infer<
  typeof LeadsAPI.subscription.response
>;
